import React, { useEffect, useState } from "react";

import { Auth } from "aws-amplify";
import Footer from "./Footer";
import GlobalLoading from "./components/GlobalLoading";
import Header from "./Header";
import { Main } from "./Main";
import { authState } from "./state/atoms";
import { useRecoilState } from "recoil";

// import { useNavigate } from "react-router-dom";


function App() {
  const [loading, setLoading] = useState(true);
  const [, setAuth]: any = useRecoilState(authState);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        if (await Auth.currentSession()) {
          const userInfo: any = await Auth.currentUserInfo();
          console.log("setAuth(userInfo)", userInfo);
          setAuth(userInfo);
        }
      } catch (e) {
        console.log("e", e);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, [setAuth]);

  return (
    <>
      {loading ? (
        <GlobalLoading />
      ) : (
        <div className="bg-slate-900 h-screen w-full">
          <Header />
          <Main />
          <Footer />
        </div>
      )}
    </>
  );
}

export default App;
